import { createFileRoute } from '@tanstack/react-router'
import EditionOverview from 'Edition/components/sections/Overview/EditionOverview'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/')({
    component: EditionOverview,
})
